<template>
<div class="control test-question-answer-options">
    <div class="test-question-answer-option-container" >
        <input
            class="input"
            type="number"
            :placeholder="trans.show_form.number_input_placeholder"
            v-model="result"
            @keydown="validateNumbers"
        >
    </div>
</div>
</template>

<script>
export default {
name: "TestQuestionNumberInputAnswer",
    props: [
        'value',
        'options',
        'trans',
    ],
    computed: {
        result: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
    },
    methods: {
        /// проверка ввода цифр для браузера firefox
        validateNumbers(event) {
            const validKeys = [
                // backspace
                8,
                // del
                46,
                // цифры
                48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
                // Стрелки
                37, 38, 39, 40
            ];

            if (event.keyCode && validKeys.indexOf(event.keyCode) === -1) {
                event.preventDefault();

                return false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../sass/variables';

.test-question-answer-options {
    padding: 0 15px;
}

.test-question-answer-option-container {
    padding: 17px 0;
}
</style>